import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, pluck } from 'rxjs/operators';
import { JobMappingState } from './state/job-mapping.state';
import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class JobMappingStore {
  public defaultState = new JobMappingState();
  private subject = new BehaviorSubject(this.defaultState);
  private store = this.subject.asObservable().pipe(distinctUntilChanged());
  get value() {
    return this.subject.getValue();
  }

  select<T>(name: string): Observable<T> {
    return this.store.pipe(pluck(name));
  }
  set(name: string, state: any) {
    this.subject.next({
      ...this.value,
      [name]: state
    });
  }
}
